var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "component-skeleton"
  }, [_c('div', {
    staticClass: "image-skeleton"
  }), _c('div', {
    staticClass: "text-skeleton"
  }, [_c('div', {
    staticClass: "title-skeleton"
  }), _c('div', {
    staticClass: "description-skeleton"
  })])]);
}]

export { render, staticRenderFns }